import React from "react";
import {
  Card,
  Col,
  Image,
  ListGroup,
  ListGroupItem,
  Row,
} from "react-bootstrap";
import jobs1 from "../assets/images/jobs1.png";
import jobsIcon1 from "../assets/images/jobsIcon1.png";
import jobsIcon2 from "../assets/images/jobsIcon2.png";
import jobLogo from "../assets/images/jobLogo.png";
import { imageUrl } from "../Config/apiUrl";

import jobsIcon3 from "../assets/images/jobsIcon3.png";
import Carousel from "react-elastic-carousel";
import { useHistory } from "react-router-dom";

const count = new Array(4).fill("");

const JobsCard = ({ showArrows = true, enableAutoPlay = false, data, className ,col =4,cusClass}) => {
  const history = useHistory();
  return (
    <div className={`job_types_section col-md-${col} ${cusClass}`}>
      {/* <Carousel itemsToScroll={1} itemsToShow={3} showArrows={showArrows}> */}
      {/* {count.map((item, i) => {
          return ( */}
      <Card 
        className={`Card_Main Job_main ${className} `}
        onClick={() => {
          data?._id &&
            history.push({
              state: data?._id,
              pathname: `/job/${data?._id}`,
            });
        }}
        style={{ cursor: "pointer" }}
      >
        <div className="d-flex card_location">
          <Image src={jobsIcon1} />
          <p
            style={{
              marginLeft: "5px",
            }}
          >
            {data?.address || "Address"}
          </p>
        </div>
         <div className="job-img-box">
         <Card.Img
          variant="top"
          src={`${imageUrl}${data?.companyId?.coverPhoto}`}
          fluid
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = jobs1;
          }}
        ></Card.Img>
         </div>
       
        <div className="job_logo_div">
          <Image
            src={`${imageUrl}${data?.companyId?.photo}`}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = jobLogo;
            }}
          />
        </div>

        <Card.Body>
          <Card.Title>{data?.title || "Title"}</Card.Title>
          <Card.Text>
            {data?.description ||
              `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod incididunt ut labore et dolore magna aliqua.`}
          </Card.Text>
          <div className="hr_in_job_card"></div>
          <Row className="job_footer_icons">
            <Col className="br-1-b">
              <Image src={jobsIcon1} />
              <p>
                {data?.jobDuration == "Fixed" ? "Permanent" : "Time Limited"}
              </p>
            </Col>
            <Col className="br-1-b">
              <Image src={jobsIcon2} />
              <p>{data?.jobType || "Job Type"}</p>
            </Col>
            <Col className="br-1-b">
              <Image src={jobsIcon3} />
              <p>{`$${parseFloat(data?.max).toFixed(2)}`}</p>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      {/* ); */}
      {/* })} */}
      {/* </Carousel> */}
    </div>
  );
};

export default JobsCard;
